import React, { useState } from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Tab,
  Modal,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import moment from "moment";
import ReactDatetime from "react-datetime";
import { Dna, Watch } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { getMarketing } from "stores";
import ListKunjunganByGetMarketing from "./ListKunjunganByGetMarketing";
import { exportPdfKunjungan } from "stores";

function ListMarketingByGetMarketing(data) {
  const dispatch = useDispatch();
  const kunjungan = useSelector((state) => state.kunjunganReducer);
  const auth = useSelector((state) => state.authReducer);
  const dataCabang = data.cabang;
  const ambilKunjungan = data.kunjungan;

  const [isLoading, setIsLoading] = React.useState(true);
  const [tglAwal, setTglAwal] = React.useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(
      0,
      0,
      0,
      0,
    ),
  );
  const [tglAkhir, setTglAkhir] = React.useState(new Date());
  const [idCabang, setIdCabang] = React.useState("");
  const [idMarketing, setIdMarketing] = React.useState("");
  const [listDataMarketing, setListDataMarketing] = React.useState([]);
  const [sendKunjunganMarketing, setSendKunjunganMarketing] = React.useState(
    [],
  );
  // const [sendDataCabang, setSendDataCabang] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleClick = () => {
    dispatch({ type: "SET_DETAIL_MARKETING", data: true });
  };

  const handleDetailsClick = (val) => {
    dispatch({ type: "SET_DETAIL_KUNJUNGAN_MARKETING", data: false });
    setSendKunjunganMarketing(val.kunjungan);
  };

  const bukaPDF = async (idMarketing) => {
    try {
      const data = {
        tglAwal: moment(tglAwal).format("YYYY-MM-DD"),
        tglAkhir: moment(tglAkhir).format("YYYY-MM-DD"),
        idMarketing: idMarketing,
      };
      const response = await exportPdfKunjungan(data);
      // console.log(response.base64, "AASASAAS");
      // const byteCharacters = atob(response.base64);
      // const byteNumbers = new Array(byteCharacters.length);
      // for (let i = 0; i < byteCharacters.length; i++) {
      //   byteNumbers[i] = byteCharacters.charCodeAt(i);
      // }
      // const byteArray = new Uint8Array(byteNumbers);
      // const blob = new Blob([byteArray], { type: "application/pdf" });
      // const blobUrl = URL.createObjectURL(blob);
      // window.open(blobUrl);
      const byteCharacters = atob(response.base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      // Create a Blob from the byte array
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      const newTab = window.open(blobUrl, "_blank");
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = "Kunjungan Marketing.pdf";
      downloadLink.style.display = "none";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      // Close the new tab if opened programmatically
      if (!newTab) {
        alert(
          "Pop-up blocker prevented opening the PDF in a new tab. Please allow pop-ups for this site.",
        );
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  // React.useEffect(() => {
  //   let tmp = [];
  //   Object.entries(data).forEach(([key, value]) => {
  //     console.log(key, "VALUEE");
  //   });
  // });

  React.useEffect(() => {
    if (data.data) {
      let tmp = data.data.map((val) => {
        return {
          ...val,
          action: (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ gap: "8px" }}
            >
              {/* BUTTON DETAIL */}
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`t-detail-${val._id}`}>Lihat Profil</Tooltip>
                }
              >
                <Button
                  className="btn-icon d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "10px",
                    backgroundColor: "#E0F2FE",
                    border: "1px solid #BAE6FD",
                    color: "#0369A1",
                    transition: "all 0.2s ease",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#0369A1";
                    e.currentTarget.style.color = "#ffffff";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "#E0F2FE";
                    e.currentTarget.style.color = "#0369A1";
                  }}
                  onClick={() => handleDetailsClick(val)}
                >
                  <i className="fas fa-eye" style={{ fontSize: "14px" }}></i>
                </Button>
              </OverlayTrigger>

              {/* BUTTON DOWNLOAD PDF */}
              {/* <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`t-pdf-${val._id}`}>Download PDF</Tooltip>
                }
              >
                <Button
                  className="btn-icon d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "10px",
                    backgroundColor: "#FFE4E6",
                    border: "1px solid #FECDD3",
                    color: "#E11D48",
                    transition: "all 0.2s ease",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#E11D48";
                    e.currentTarget.style.color = "#ffffff";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "#FFE4E6";
                    e.currentTarget.style.color = "#E11D48";
                  }}
                  onClick={() => bukaPDF(val._id)}
                >
                  <i
                    className="fas fa-file-pdf"
                    style={{ fontSize: "14px" }}
                  ></i>
                </Button>
              </OverlayTrigger> */}
            </div>
          ),
        };
      });
      setListDataMarketing(tmp);
    }
  }, [data.data]);

  const options = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  const getStatusUser = (statusUser) => {
    switch (statusUser) {
      case "tidak aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#E3EEF9",
          textColor: "#1569C7",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "#F1F5F9",
        minHeight: "50px",
        borderTop: "1px solid #E2E8F0",
      },
    },
    headCells: {
      style: {
        fontWeight: "800",
        fontSize: "11px",
        color: "#475569",
        textTransform: "uppercase",
        justifyContent: "center",
      },
    },
    rows: {
      style: {
        minHeight: "65px",
        "&:hover": {
          backgroundColor: "#F8FAFC",
          transition: "0.2s",
        },
      },
    },
    cells: {
      style: {
        fontSize: "13px",
        color: "#1E293B",
        justifyContent: "center",
      },
    },
  };

  const colKunjungan = [
    {
      name: "NO",
      width: "70px",
      center: true,
      selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
      style: { fontWeight: "bold", color: "#94A3B8" },
    },
    {
      name: "MARKETING",
      minWidth: "220px",
      cell: (row) => (
        <div className="py-2">
          {/* Nama: Bold & Standar */}
          <div className="fw-800 text-dark" style={{ fontSize: "14px" }}>
            {row.nama}
          </div>
          {/* Nopeg: Kecil di bawah nama sebagai sub-info */}
          <div
            className="text-muted fw-800"
            style={{ fontSize: "15px", marginTop: "2px" }}
          >
            <span className="badge bg-light border mr-1">
              NOPEG: {row.nopeg}
            </span>
          </div>
        </div>
      ),
    },
    {
      name: "NIK",
      minWidth: "180px",
      center: true,
      cell: (row) => (
        <span
          className="fw-700 text-dark font-monospace"
          style={{
            fontSize: "13px",
            letterSpacing: "0.5px",
            backgroundColor: "#F8FAFC",
            padding: "4px 10px",
            borderRadius: "6px",
            border: "1px solid #E2E8F0",
          }}
        >
          {row.nik}
        </span>
      ),
    },
    {
      name: "JABATAN",
      minWidth: "200px",
      cell: (row) => (
        <div
          className="text-center px-2 py-1 rounded border bg-light"
          style={{ fontSize: "11px", fontWeight: "800" }}
        >
          {row.role === "marketing"
            ? "SALES MARKETING"
            : "DIRECT SALES MARKETING"}
        </div>
      ),
    },
    {
      name: "TOTAL KUNJUNGAN",
      minWidth: "180px",
      center: true,
      cell: (row) => (
        <div className="text-center">
          <span className="fw-800 text-primary" style={{ fontSize: "15px" }}>
            {row.kunjungan?.length || 0}
          </span>
          <div className="text-muted small" style={{ fontSize: "10px" }}>
            AKTIVITAS
          </div>
        </div>
      ),
    },
    {
      name: "STATUS",
      minWidth: "150px",
      center: true,
      cell: (row) => {
        const isAktif = row.status === "aktif";
        return (
          <span
            style={{
              fontSize: "11px",
              fontWeight: "800",
              padding: "6px 15px",
              borderRadius: "20px",
              backgroundColor: isAktif ? "#DCFCE7" : "#F1F5F9",
              color: isAktif ? "#15803D" : "#64748B",
              border: isAktif ? "1px solid #BBF7D0" : "1px solid #E2E8F0",
            }}
          >
            {isAktif ? "AKTIF" : "NON-AKTIF"}
          </span>
        );
      },
    },
    {
      name: "AKSI",
      width: "120px",
      center: true,
      cell: (row) => (
        <div className="d-flex justify-content-center">{row.action}</div>
      ),
    },
  ];

  React.useEffect(() => {
    setIsLoading(true);
    getMarketing(dispatch, {
      tglAwal: moment(tglAwal).format("YYYY-MM-DD"),
      tglAkhir: moment(tglAkhir).format("YYYY-MM-DD"),
      idCabang: idCabang,
      idMarketing: idMarketing,
    })
      .then((response) => {
        // setLoading(false);
        setIsLoading(false);
      })
      .catch((error) => {
        // setLoading(false);
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [tglAwal, tglAkhir]);

  return (
    <>
      {kunjungan.detailKunjunganMarketing ? (
        <Container fluid className="py-4">
          {/* BACK BUTTON: Modern Floating Style */}
          <Button
            className="btn-icon shadow-sm mb-4 d-flex align-items-center justify-content-center"
            style={{
              width: "42px",
              height: "42px",
              borderRadius: "12px",
              backgroundColor: "#fff",
              border: "1px solid #e2e8f0",
              color: "#F75D59",
              transition: "all 0.3s ease",
            }}
            onClick={handleClick}
          >
            <i className="fas fa-arrow-left"></i>
          </Button>

          <Row>
            <Col md="12">
              <Card className="border-0 shadow-sm rounded-xl">
                <Card.Header className="bg-white border-0 pt-4 px-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <h3
                        className="fw-800 text-dark m-0"
                        style={{ letterSpacing: "1px" }}
                      >
                        LIST DATA MARKETING
                      </h3>
                      <p className="text-muted small mb-0">
                        Monitor performa individu dan rekapitulasi kunjungan tim
                        marketing.
                      </p>
                    </div>
                    {/* Context Badge */}
                    <div className="bg-light-red px-3 py-2 rounded-pill border border-danger-subtle d-none d-md-block">
                      <span className="text-danger fw-bold small">
                        <i className="fas fa-user-tag mr-2"></i>
                        Analisis Kinerja
                      </span>
                    </div>
                  </div>

                  {/* COMPACT FILTER BAR */}
                  <div className="bg-light p-3 rounded-xl border-0 mt-3 shadow-inner">
                    <Row className="align-items-end g-3">
                      <Col md={3} sm={6}>
                        <label className="text-muted small fw-bold uppercase mb-2 d-block ml-1">
                          <i className="far fa-calendar-alt mr-2 text-danger"></i>
                          Mulai Tanggal
                        </label>
                        <div className="date-picker-wrapper shadow-sm rounded-lg bg-white p-1">
                          <ReactDatetime
                            inputProps={{
                              className: "form-control border-0 bg-transparent",
                              placeholder: "Pilih Tanggal",
                              readOnly: true,
                              style: {
                                cursor: "pointer",
                                fontWeight: "600",
                                color: "#334155",
                              },
                            }}
                            onChange={(e) => {
                              const date = e.toDate
                                ? e.toDate().setHours(0, 0, 0, 0)
                                : e;
                              setTglAwal(date);
                            }}
                            value={tglAwal}
                            timeFormat={false}
                            closeOnSelect={true}
                          />
                        </div>
                      </Col>

                      <Col md={3} sm={6}>
                        <label className="text-muted small fw-bold uppercase mb-2 d-block ml-1">
                          <i className="far fa-calendar-check mr-2 text-danger"></i>
                          Sampai Tanggal
                        </label>
                        <div className="date-picker-wrapper shadow-sm rounded-lg bg-white p-1">
                          <ReactDatetime
                            inputProps={{
                              className: "form-control border-0 bg-transparent",
                              placeholder: "Pilih Tanggal",
                              readOnly: true,
                              style: {
                                cursor: "pointer",
                                fontWeight: "600",
                                color: "#334155",
                              },
                            }}
                            onChange={(e) => {
                              const date = e.toDate
                                ? e.toDate().setHours(0, 0, 0, 0)
                                : e;
                              setTglAkhir(date);
                            }}
                            value={tglAkhir}
                            timeFormat={false}
                            closeOnSelect={true}
                          />
                        </div>
                      </Col>

                      <Col md="auto" className="ml-md-2 mt-3 mt-md-0">
                        <Button
                          className="px-4 fw-800 shadow-sm border-0 d-flex align-items-center justify-content-center"
                          style={{
                            backgroundColor: "#F75D59",
                            borderRadius: "10px",
                            height: "46px",
                            color: "white",
                            minWidth: "150px",
                          }}
                        >
                          <i className="fas fa-sync mr-2"></i> REFRESH LIST
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </Card.Header>

                <Card.Body className="px-4 pb-4 mt-2">
                  {isLoading ? (
                    <div className="py-5 text-center d-flex flex-column align-items-center">
                      <Watch height="70" width="70" color="#F75D59" />
                      <h5 className="mt-4 fw-600 text-muted animate-pulse">
                        Menghitung Data Marketing...
                      </h5>
                    </div>
                  ) : (
                    <div className="table-responsive-custom">
                      <DataTable
                        columns={colKunjungan}
                        data={listDataMarketing}
                        customStyles={customStyles}
                        pagination
                        paginationPerPage={itemsPerPage}
                        onChangePage={handlePageChange}
                        highlightOnHover
                        pointerOnHover
                      />
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <style>{`
    .fw-800 { font-weight: 800; }
    .rounded-xl { border-radius: 20px !important; }
    .rounded-lg { border-radius: 12px !important; }
    .shadow-inner { box-shadow: inset 0 2px 4px 0 rgba(0,0,0,0.06); }
    .bg-light-red { background-color: #fff1f2; }
    
    /* Hover effects for custom elements */
    .btn-icon:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
    }

    /* Datetime Customization */
    .rdtPicker { 
      border-radius: 12px !important; 
      border: 1px solid #e2e8f0 !important;
      padding: 10px !important;
    }
    .rdtDay.rdtActive, .rdtDay.rdtActive:hover {
      background-color: #F75D59 !important;
      border-radius: 8px;
    }
    
    /* Table styling to match the new look */
    .rdt_Table { 
      border: 1px solid #f1f5f9; 
      border-radius: 15px; 
      overflow: hidden;
    }
    
    @keyframes pulse {
      0% { opacity: 1; }
      50% { opacity: 0.5; }
      100% { opacity: 1; }
    }
    .animate-pulse { animation: pulse 2s infinite; }
  `}</style>
        </Container>
      ) : (
        <>
          <ListKunjunganByGetMarketing
            data={sendKunjunganMarketing}
            cabang={dataCabang}
          />
        </>
      )}
    </>
  );
}

export default ListMarketingByGetMarketing;
